import { render, staticRenderFns } from "./CTab.vue?vue&type=template&id=08c98b62"
import script from "./CTab.vue?vue&type=script&lang=js"
export * from "./CTab.vue?vue&type=script&lang=js"
import style0 from "./CTab.vue?vue&type=style&index=0&id=08c98b62&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c98b62')) {
      api.createRecord('08c98b62', component.options)
    } else {
      api.reload('08c98b62', component.options)
    }
    module.hot.accept("./CTab.vue?vue&type=template&id=08c98b62", function () {
      api.rerender('08c98b62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CTab.vue"
export default component.exports